import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import generateSchema from './clientForm.schema';

import { ModalTitles } from './constants';

import {
  featureFlagsSelector,
} from '../../shared/store/selectors';

import {
  ClientPropTypes,
  FeatureFlagsPropTypes,
} from './propTypes';

class AddEditModal extends PureComponent {
  static propTypes = {
    entityToEdit: ClientPropTypes,
    featureFlags: FeatureFlagsPropTypes,
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    isSavingEntity: PropTypes.bool.isRequired,
    openForEdit: PropTypes.bool,
    isVisible: PropTypes.bool,
  };

  save = ({ files, ...formData }, { setSubmitting, resetForm }) => {
    const { saveEntity, openForEdit, entityToEdit } = this.props;

    saveEntity({
      ...formData,
      icon: files ? files.image : null,
    }, openForEdit, { params: { clientId: entityToEdit?.clientId }, callback: resetForm });
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      hideModal,
      isVisible,
      isSavingEntity,
    } = this.props;

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-edit-clients-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={formik.handleSubmit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingEntity}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, featureFlags } = this.props;

    const schema = generateSchema({ featureFlags: Object.values(featureFlags) });

    const formattedEntityToEdit = entityToEdit
      ? {
        ...entityToEdit,
        files: entityToEdit.icon
          ? {
            image: entityToEdit.icon,
            name: 'Icon',
            type: 'image',
          }
          : null,
      }
      : null;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={formattedEntityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  featureFlags: featureFlagsSelector(state),
});

export default connect(
  mapStateToProps
)(AddEditModal);
